export const MODALITY = {
	ALL: 0,
	CONVENTIONAL: 1,
	SCHEDULED: 4
};

export const STATUS = {
	ALL: 0,
	RECEIVED: 1,
	TO_BE_RECEIVED: 2,
	CANCELED: 3,
	RESALE: 4,
	SUSPENDED: 5,
	FROZEN_PAYMENT: 6,
	BANK_DATA_DIVERGENCE: 7,
	ANALYSIS: 8
};

export const PAYMENT_SCHEDULE_TYPE = {
	WORKING_DAYS: "dias úteis",
	CALENDAR_DAYS: "dias corridos"
}